import moment from 'moment';
import 'moment/locale/nl';

moment().local();
moment().locale('nl');
